// import React, { useEffect, useState } from 'react';
// import FurnitureNavbar from '../../../components/layout/Nav';
// import './myrequests.scss';
// import withAuth from '../../auth/WithAuth';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';
// import {
//   FaStar,
//   FaCamera,
//   FaImage,
//   FaUserCircle,
//   FaBriefcase,
//   FaCheckCircle,
//   FaClock,
//   FaFileAlt,
//   FaTimes,
//   FaMoneyBillWave,
//   FaCalendar,
//   FaEnvelope,
//   FaComments,
//   FaSpinner,
// } from 'react-icons/fa';
// import { Link, useNavigate } from 'react-router-dom';

// const MyRequests = () => {
//   // ========== STATE MANAGEMENT ==========

//   // Main data states
//   const [requests, setRequests] = useState([]);
//   const [filter, setFilter] = useState('all');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Matched artisans states
//   const [matchedArtisans, setMatchedArtisans] = useState([]);
//   const [loadingMatches, setLoadingMatches] = useState(false);

//   // Modal states
//   const [viewRequest, setViewRequest] = useState(null);
//   const [editRequest, setEditRequest] = useState(null);
//   const [deleteRequest, setDeleteRequest] = useState(null);
//   const [portfolioModal, setPortfolioModal] = useState(null);

//   // Proposal viewing states
//   const [showProposalModal, setShowProposalModal] = useState(false);
//   const [viewingProposal, setViewingProposal] = useState(null);
//   const [loadingProposal, setLoadingProposal] = useState(false);
//   const [acceptingProposal, setAcceptingProposal] = useState(false);

//   // Auto-open matches modal from sessionStorage
//   const [autoOpenProjectId, setAutoOpenProjectId] = useState(null);
//   const [showPriceAgreedMessage, setShowPriceAgreedMessage] = useState(false);
//   const [selectedArtisanId, setSelectedArtisanId] = useState(null);

//   // Rating states
//   const [rating, setRating] = useState(0);
//   const [hoverRating, setHoverRating] = useState(0);
//   const [ratingReview, setRatingReview] = useState('');
//   const [ratingImages, setRatingImages] = useState([]);
//   const [ratingPreviewUrls, setRatingPreviewUrls] = useState([]);
//   const [existingRating, setExistingRating] = useState(null);
//   const [isSubmittingRating, setIsSubmittingRating] = useState(false);

//   // UI states
//   const [activeImage, setActiveImage] = useState(0);
//   const [carouselIndex, setCarouselIndex] = useState({});
//   const [expandedBios, setExpandedBios] = useState({});
//   const [expandedDescriptions, setExpandedDescriptions] = useState({});

//   // Confirmation modal states
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [selectedMatchForConfirm, setSelectedMatchForConfirm] = useState(null);

//   const navigate = useNavigate();

//   // Form states
//   const [projectData, setProjectData] = useState({
//     title: '',
//     description: '',
//     budget: '',
//     location: '',
//     deadline: '',
//   });
//   const [newImages, setNewImages] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);

//   // ========== API FUNCTIONS ==========

//   const fetchClientProjects = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await serverUrlAuth.get('projects/client-projects/');
//       setRequests(res.data);
//     } catch (err) {
//       console.error('Error fetching projects:', err);
//       setError('Failed to fetch project requests.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchMatchedArtisans = async (projectId) => {
//     setLoadingMatches(true);
//     try {
//       const res = await serverUrlAuth.get(
//         `projects/client/projects/${projectId}/matches/`,
//       );
//       console.log('Matched artisans response:', res.data);
//       setMatchedArtisans(res.data);
//     } catch (err) {
//       console.error('Error fetching matched artisans:', err);
//       toast.error('Failed to load matched artisans');
//     } finally {
//       setLoadingMatches(false);
//     }
//   };

//   // ✅ Fetch proposal details using the new endpoint
//   const fetchProposalDetails = async (proposalId) => {
//     setLoadingProposal(true);
//     try {
//       const response = await serverUrlAuth.get(
//         `proposals/proposal-detail/${proposalId}/`,
//       );
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching proposal details:', error);
//       toast.error('Failed to load proposal details');
//       return null;
//     } finally {
//       setLoadingProposal(false);
//     }
//   };

//   // ✅ Handle viewing a proposal
//   const handleViewProposal = async (match) => {
//     if (!match.has_proposal || !match.proposal_id) {
//       toast.error('No proposal found for this artisan');
//       return;
//     }

//     const proposal = await fetchProposalDetails(match.proposal_id);
//     if (proposal) {
//       setViewingProposal({
//         ...proposal,
//         artisan_name: match.artisan_name,
//         artisan_id: match.artisan_id,
//       });
//       setShowProposalModal(true);
//     }
//   };

//   const fetchPortfolioData = async (artisanId) => {
//     try {
//       const response = await serverUrlAuth.get(
//         `portfolio/artisan-portfolio/${artisanId}/`,
//       );
//       return response.data;
//     } catch (err) {
//       console.error('Error fetching portfolio:', err);
//     }
//   };

//   const fetchRating = async () => {
//     if (!viewRequest?.id) return;
//     try {
//       const res = await serverUrlAuth.get(
//         `reviews/project-review/${viewRequest.id}/`,
//       );
//       if (res.data) {
//         setExistingRating(res.data);
//         setRating(res.data.score || 0);
//         setRatingReview(res.data.review || '');
//         setRatingPreviewUrls(
//           res.data.images?.map((img) => img.image_url) || [],
//         );
//       }
//     } catch (err) {
//       if (err.response?.status !== 404) {
//         toast.error('Failed to fetch rating');
//       }
//     }
//   };

//   // ========== PROJECT MANAGEMENT FUNCTIONS ==========

//   const handleDeleteProject = async () => {
//     if (!deleteRequest) return;
//     try {
//       await serverUrlAuth.delete(
//         `projects/client-project/${deleteRequest.id}/`,
//       );
//       toast.success(`Project "${deleteRequest.title}" deleted`);
//       setRequests((prev) => prev.filter((r) => r.id !== deleteRequest.id));
//       setDeleteRequest(null);
//     } catch (err) {
//       toast.error('Failed to delete project');
//     }
//   };

//   const handleEditProject = async () => {
//     if (!editRequest) return;
//     try {
//       const formData = new FormData();
//       Object.entries(projectData).forEach(([key, value]) =>
//         formData.append(key, value),
//       );
//       newImages.forEach((file) => formData.append('images', file));

//       await serverUrlAuth.patch(
//         `projects/client-project/${editRequest.id}/`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } },
//       );

//       toast.success(`Project "${projectData.title}" updated`);
//       setEditRequest(null);
//       resetEditForm();
//       fetchClientProjects();
//     } catch (err) {
//       toast.error('Failed to update project');
//     }
//   };

//   // ========== RATING FUNCTIONS ==========

//   const handleSubmitRating = async () => {
//     if (!rating || !viewRequest?.id) {
//       toast.error('Please select a rating');
//       return;
//     }

//     setIsSubmittingRating(true);
//     try {
//       const formData = new FormData();
//       formData.append('score', rating);
//       formData.append('review', ratingReview);
//       ratingImages.forEach((file) => formData.append('images', file));

//       const res = await serverUrlAuth.post(
//         `reviews/project-review/${viewRequest.id}/create/`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } },
//       );

//       toast.success('Review submitted successfully!');
//       setExistingRating(res.data);
//       resetRatingForm();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to submit rating');
//     } finally {
//       setIsSubmittingRating(false);
//     }
//   };

//   // ========== UI HANDLERS ==========

//   const handleSelectArtisan = (match) => {
//     if (!match.has_proposal) {
//       toast.error('No proposal found for this artisan');
//       return;
//     }

//     // Open confirmation modal instead of directly selecting
//     setSelectedMatchForConfirm(match);
//     setShowConfirmModal(true);
//   };

//   const confirmSelectArtisan = async () => {
//     if (!selectedMatchForConfirm) return;

//     setAcceptingProposal(true);
//     try {
//       await serverUrlAuth.patch(
//         `proposals/${selectedMatchForConfirm.proposal_id}/select/`,
//       );
//       toast.success(
//         `You have selected ${selectedMatchForConfirm.artisan_name} for this project!`,
//       );
//       setViewRequest(null);
//       fetchClientProjects();
//       setShowConfirmModal(false);
//       setSelectedMatchForConfirm(null);
//     } catch (err) {
//       console.error('Error selecting artisan:', err);
//       toast.error('Failed to select artisan');
//     } finally {
//       setAcceptingProposal(false);
//     }
//   };

//   const handleViewProject = async (project) => {
//     setViewRequest(project);
//     if (project.status.toLowerCase() === 'open') {
//       await fetchMatchedArtisans(project.id);
//     }
//     if (project.status.toLowerCase() === 'completed') {
//       fetchRating();
//     }
//   };

//   const openPortfolio = async (artisanId, artisanName) => {
//     const portfolioData = await fetchPortfolioData(artisanId);
//     setPortfolioModal({ ...portfolioData, artisan_name: artisanName });
//     setViewRequest(null);
//   };

//   const closePortfolio = () => setPortfolioModal(null);

//   const openEditModal = (request) => {
//     setEditRequest(request);
//     setProjectData({
//       title: request.title || '',
//       description: request.description || '',
//       budget: request.budget || '',
//       location: request.location || '',
//       deadline: request.deadline?.split('T')[0] || '',
//     });
//     setNewImages([]);
//     setPreviewUrls([]);
//   };

//   const toggleBio = (artisanId) => {
//     setExpandedBios((prev) => ({
//       ...prev,
//       [artisanId]: !prev[artisanId],
//     }));
//   };

//   const toggleDescription = (projectId) => {
//     setExpandedDescriptions((prev) => ({
//       ...prev,
//       [projectId]: !prev[projectId],
//     }));
//   };

//   // ========== UTILITY FUNCTIONS ==========

//   const handleImageUpload = (e, setImages, setPreviews) => {
//     const files = Array.from(e.target.files);
//     setImages((prev) => [...prev, ...files]);
//     setPreviews((prev) => [
//       ...prev,
//       ...files.map((file) => URL.createObjectURL(file)),
//     ]);
//   };

//   const handleRemoveImage = (index, setImages, setPreviews) => {
//     setImages((prev) => prev.filter((_, i) => i !== index));
//     setPreviews((prev) => prev.filter((_, i) => i !== index));
//   };

//   const resetRatingForm = () => {
//     setRating(0);
//     setRatingReview('');
//     setRatingImages([]);
//     setRatingPreviewUrls([]);
//   };

//   const resetEditForm = () => {
//     setNewImages([]);
//     setPreviewUrls([]);
//   };

//   // ========== UI HELPERS ==========

//   const shouldShowEditDelete = (status) =>
//     ['open', 'pending'].includes(status.toLowerCase());

//   const normalize = (str) => str.toLowerCase().replace(/\s+/g, '');

//   const filteredRequests =
//     filter === 'all'
//       ? requests
//       : requests.filter((r) => normalize(r.status) === normalize(filter));

//   const handleNext = (projectId, totalImages) => {
//     setCarouselIndex((prev) => ({
//       ...prev,
//       [projectId]: ((prev[projectId] || 0) + 1) % totalImages,
//     }));
//   };

//   const handlePrev = (projectId, totalImages) => {
//     setCarouselIndex((prev) => ({
//       ...prev,
//       [projectId]:
//         (prev[projectId] || 0) === 0
//           ? totalImages - 1
//           : (prev[projectId] || 0) - 1,
//     }));
//   };

//   const getTierBadgeClass = (tier) => {
//     switch (tier?.toLowerCase()) {
//       case 'bronze':
//         return 'tier-bronze';
//       case 'silver':
//         return 'tier-silver';
//       case 'gold':
//         return 'tier-gold';
//       default:
//         return 'tier-bronze';
//     }
//   };

//   const getTierIcon = (tier) => {
//     switch (tier?.toLowerCase()) {
//       case 'bronze':
//         return '🥉';
//       case 'silver':
//         return '🥈';
//       case 'gold':
//         return '🥇';
//       default:
//         return '🥉';
//     }
//   };

//   // ========== EFFECTS ==========

//   useEffect(() => {
//     const projectId = sessionStorage.getItem('openProjectMatches');
//     const showMessage = sessionStorage.getItem('showPriceAgreedMessage');
//     const artisanId = sessionStorage.getItem('selectedArtisanId');

//     if (projectId) {
//       setAutoOpenProjectId(projectId);
//       if (showMessage) {
//         setShowPriceAgreedMessage(true);
//         setTimeout(() => setShowPriceAgreedMessage(false), 5000);
//       }
//       if (artisanId) {
//         setSelectedArtisanId(artisanId);
//       }
//       sessionStorage.removeItem('openProjectMatches');
//       sessionStorage.removeItem('showPriceAgreedMessage');
//       sessionStorage.removeItem('selectedArtisanId');
//     }
//   }, []);

//   useEffect(() => {
//     if (autoOpenProjectId && requests.length > 0) {
//       const project = requests.find(
//         (r) => r.id.toString() === autoOpenProjectId.toString(),
//       );
//       if (project && project.status.toLowerCase() === 'open') {
//         handleViewProject(project);
//         setAutoOpenProjectId(null);
//       }
//     }
//   }, [requests, autoOpenProjectId]);

//   useEffect(() => {
//     fetchClientProjects();
//   }, []);

//   useEffect(() => {
//     if (viewRequest) {
//       setActiveImage(0);
//       if (viewRequest.status.toLowerCase() === 'open') {
//         fetchMatchedArtisans(viewRequest.id);
//       }
//       if (viewRequest.status.toLowerCase() === 'completed') {
//         fetchRating();
//       } else {
//         resetRatingForm();
//         setExistingRating(null);
//       }
//     }
//   }, [viewRequest]);

//   // ========== RENDER ==========

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="my-requests-page">
//         <section className="requests-hero">
//           <div className="hero-overlay">
//             <div className="hero-content">
//               <h1>🧾 My Project Requests</h1>
//               <p>
//                 Track all your custom furniture and design requests in one
//                 place.
//               </p>
//               <div className="hero-actions">
//                 <Link to="/new-project">
//                   <button className="hero-new-project-btn">
//                     <span className="btn-icon">+</span> Create New Project
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Filter */}
//         <div className="filter-bar container">
//           {['all', 'open', 'in-progress', 'completed'].map((status) => (
//             <button
//               key={status}
//               className={filter === status ? 'active' : ''}
//               onClick={() => setFilter(status)}
//             >
//               {status.charAt(0).toUpperCase() + status.slice(1)}
//             </button>
//           ))}
//         </div>

//         {/* Requests Grid */}
//         <div className="requests-grid container">
//           {loading ? (
//             <p className="loading">Loading your requests...</p>
//           ) : error ? (
//             <p className="error">{error}</p>
//           ) : filteredRequests.length === 0 ? (
//             <div className="empty-div">
//               <p className="empty">No projects found.</p>
//               {requests.length === 0 && (
//                 <Link to="/new-project">
//                   <Button className="new-project-btn">
//                     Create New Project
//                   </Button>
//                 </Link>
//               )}
//             </div>
//           ) : (
//             filteredRequests.map((req) => {
//               return (
//                 <div className="request-card" key={req.id}>
//                   <div className="thumbnail">
//                     <img
//                       src={
//                         req.images?.length
//                           ? req.images[0].image_url
//                           : 'https://via.placeholder.com/400x300'
//                       }
//                       alt={req.title}
//                     />
//                     <span
//                       className={`status ${req.status
//                         .toLowerCase()
//                         .replace(' ', '-')}`}
//                     >
//                       {req.status}
//                     </span>
//                     {req.proposals_count > 0 &&
//                       req.status.toLowerCase() === 'open' && (
//                         <p className="proposals-badge">
//                           {req.proposals_count === 1
//                             ? '1 proposal'
//                             : `${req.proposals_count} proposals`}
//                         </p>
//                       )}
//                   </div>
//                   <div className="card-content">
//                     <h3>{req.title}</h3>
//                     {!req.agreed_cost ? (
//                       <p className="budget">
//                         💰 Budget:{' '}
//                         <strong>
//                           KSh {parseFloat(req.budget).toLocaleString()}
//                         </strong>
//                       </p>
//                     ) : (
//                       <p className="budget">
//                         💰 Agreed Cost:{' '}
//                         <strong>
//                           KSh {parseFloat(req.agreed_cost).toLocaleString()}
//                         </strong>
//                       </p>
//                     )}
//                     <p className="date">
//                       📅 {new Date(req.created_at).toLocaleDateString()}
//                     </p>
//                     <div className="actions">
//                       <button
//                         className="view-btn"
//                         onClick={() => handleViewProject(req)}
//                       >
//                         {req.status.toLowerCase() === 'open'
//                           ? 'View Artisan Matches'
//                           : req.status.toLowerCase() === 'completed'
//                             ? existingRating
//                               ? 'Rated • View Project'
//                               : 'Rate Project'
//                             : req.status.toLowerCase() === 'in progress'
//                               ? 'View Progress'
//                               : 'View'}
//                       </button>
//                       {shouldShowEditDelete(req.status) && (
//                         <>
//                           <button
//                             className="edit-btn"
//                             onClick={() => openEditModal(req)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="delete-btn"
//                             onClick={() => setDeleteRequest(req)}
//                           >
//                             Delete
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })
//           )}
//         </div>
//       </div>

//       {/* Project Details Modal with Matched Artisans */}
//       <Modal
//         show={!!viewRequest}
//         onHide={() => setViewRequest(null)}
//         centered
//         size="xl"
//         className="project-details-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {viewRequest?.status.toLowerCase() === 'completed'
//               ? 'Rate Project'
//               : viewRequest?.status.toLowerCase() === 'open'
//                 ? 'Matched Artisans'
//                 : 'Project Details'}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {viewRequest && (
//             <div className="modal-two-column-layout">
//               {/* Left Side - Images */}
//               <div className="modal-left-side">
//                 <div className="image-carousel">
//                   <div className="main-image-container">
//                     <img
//                       src={
//                         viewRequest.images?.length
//                           ? viewRequest.images[activeImage].image
//                           : 'https://via.placeholder.com/400x300'
//                       }
//                       alt={viewRequest.title}
//                       className="main-image"
//                     />
//                   </div>
//                   {viewRequest.images?.length > 1 && (
//                     <div className="thumbnail-strip">
//                       {viewRequest.images.map((img, idx) => (
//                         <img
//                           key={idx}
//                           src={img.image}
//                           alt={`Thumb ${idx + 1}`}
//                           className={`thumbnail ${
//                             activeImage === idx ? 'active' : ''
//                           }`}
//                           onClick={() => setActiveImage(idx)}
//                         />
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Right Side - Content */}
//               <div className="modal-right-side">
//                 <div className="content-section">
//                   <h3 className="project-title">{viewRequest.title}</h3>

//                   <div className="project-details">
//                     <p>
//                       <strong>Status:</strong> {viewRequest.status}
//                     </p>
//                     {!viewRequest.agreed_cost ? (
//                       <p>
//                         <strong>Budget:</strong> KSh{' '}
//                         {parseFloat(viewRequest.budget).toLocaleString()}
//                       </p>
//                     ) : (
//                       <p>
//                         <strong>Agreed Cost:</strong> KSh{' '}
//                         {parseFloat(viewRequest.agreed_cost).toLocaleString()}
//                       </p>
//                     )}
//                     <p>
//                       <strong>Deadline:</strong>{' '}
//                       {new Date(viewRequest.deadline).toLocaleDateString()}
//                     </p>
//                     <p>
//                       <strong>Description:</strong> {viewRequest.description}
//                     </p>
//                   </div>

//                   {/* Matched Artisans Section for Open Projects */}
//                   {viewRequest.status.toLowerCase() === 'open' && (
//                     <div className="matched-artisans-section">
//                       <div className="section-header">
//                         <h4>🤝 Matched Artisans ({matchedArtisans.length})</h4>
//                         <p className="match-info">
//                           Based on your budget of KSh{' '}
//                           {parseFloat(viewRequest.budget).toLocaleString()},
//                           we've found {matchedArtisans.length} skilled artisans
//                           who match your requirements.
//                         </p>
//                       </div>

//                       {loadingMatches ? (
//                         <div className="loading-matches">
//                           <div className="spinner"></div>
//                           <p>Finding the best artisans for you...</p>
//                         </div>
//                       ) : matchedArtisans.length === 0 ? (
//                         <div className="no-matches">
//                           <div className="no-matches-icon">🔍</div>
//                           <h5>No matches found yet</h5>
//                           <p>
//                             We're still looking for artisans who match your
//                             requirements. Check back soon!
//                           </p>
//                         </div>
//                       ) : (
//                         <div className="matched-artisans-list">
//                           {matchedArtisans.map((match) => (
//                             <div
//                               key={match.id}
//                               className="matched-artisan-card"
//                             >
//                               <div className="artisan-header">
//                                 <div className="artisan-avatar">
//                                   <FaUserCircle className="avatar-placeholder" />
//                                 </div>
//                                 <div className="artisan-info">
//                                   <h5>
//                                     {match.artisan_name ||
//                                       `Artisan ${match.artisan_id}`}
//                                   </h5>
//                                   <div className="artisan-meta">
//                                     <span
//                                       className={`tier-badge ${getTierBadgeClass(match.tier)}`}
//                                     >
//                                       {getTierIcon(match.tier)}{' '}
//                                       {match.tier?.toUpperCase() || 'BRONZE'}
//                                     </span>
//                                     <div className="rating">
//                                       <FaStar className="star-icon" />
//                                       <span>
//                                         {match.average_rating || 'New'}
//                                       </span>
//                                     </div>
//                                   </div>
//                                 </div>
//                                 <div className="match-status">
//                                   {match.has_proposal ? (
//                                     <span
//                                       className={`proposal-status-badge ${match.proposal_selected ? 'accepted' : 'pending'}`}
//                                     >
//                                       {match.proposal_selected ? (
//                                         <>✅ Selected</>
//                                       ) : (
//                                         <>📝 Proposal Received</>
//                                       )}
//                                     </span>
//                                   ) : (
//                                     <span className="proposal-status-badge no-proposal">
//                                       <FaClock /> Waiting for Proposal
//                                     </span>
//                                   )}
//                                 </div>
//                               </div>

//                               <div className="artisan-bio-preview">
//                                 <p>
//                                   {match.bio ||
//                                     'Skilled artisan ready to work on your project.'}
//                                 </p>
//                               </div>
//                               <div className="artisan-actions">
//                                 <button
//                                   className="view-portfolio-btn"
//                                   onClick={() =>
//                                     openPortfolio(
//                                       match.artisan_id,
//                                       match.artisan_name,
//                                     )
//                                   }
//                                 >
//                                   <FaBriefcase /> View Portfolio
//                                 </button>

//                                 {match.has_proposal ? (
//                                   <>
//                                     <button
//                                       className="view-proposal-btn"
//                                       onClick={() => handleViewProposal(match)}
//                                     >
//                                       <FaFileAlt /> View Proposal
//                                     </button>
//                                     <button
//                                       className="select-artisan-btn"
//                                       onClick={() => handleSelectArtisan(match)}
//                                       disabled={acceptingProposal}
//                                     >
//                                       <FaCheckCircle />
//                                       {acceptingProposal
//                                         ? 'Selecting...'
//                                         : 'Select Artisan'}
//                                     </button>
//                                   </>
//                                 ) : (
//                                   <button
//                                     className="waiting-proposal-btn"
//                                     disabled
//                                   >
//                                     <FaClock /> Awaiting Proposal
//                                   </button>
//                                 )}
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   )}

//                   {/* Rating Section for Completed Projects */}
//                   {viewRequest.status.toLowerCase() === 'completed' && (
//                     <div className="rating-section">
//                       {existingRating ? (
//                         <div className="existing-rating">
//                           <h5>Your Review</h5>
//                           <div className="stars-display">
//                             {[...Array(5)].map((_, i) => (
//                               <FaStar
//                                 key={i}
//                                 className="star"
//                                 color={
//                                   i < existingRating.score
//                                     ? '#ffc107'
//                                     : '#e4e5e9'
//                                 }
//                               />
//                             ))}
//                           </div>
//                           {existingRating.review && (
//                             <div className="review-text">
//                               <strong>Comment:</strong> {existingRating.review}
//                             </div>
//                           )}
//                           {existingRating.images?.length > 0 && (
//                             <div className="rating-images">
//                               <strong>Photos:</strong>
//                               <div className="images-grid">
//                                 {existingRating.images.map((img, idx) => (
//                                   <img
//                                     key={idx}
//                                     src={img.image_url}
//                                     alt={`Review ${idx + 1}`}
//                                   />
//                                 ))}
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       ) : (
//                         <div className="new-rating">
//                           <h4>Rate Your Experience</h4>
//                           <div className="stars-rating">
//                             <label>Your Rating:</label>
//                             <div className="stars-container">
//                               {[1, 2, 3, 4, 5].map((star) => (
//                                 <FaStar
//                                   key={star}
//                                   className={`star ${
//                                     star <= (hoverRating || rating)
//                                       ? 'active'
//                                       : ''
//                                   }`}
//                                   size={28}
//                                   onMouseEnter={() => setHoverRating(star)}
//                                   onMouseLeave={() => setHoverRating(0)}
//                                   onClick={() => setRating(star)}
//                                 />
//                               ))}
//                             </div>
//                             <div className="rating-value">
//                               {rating > 0
//                                 ? `You rated: ${rating} star${
//                                     rating > 1 ? 's' : ''
//                                   }`
//                                 : 'Click to rate'}
//                             </div>
//                           </div>

//                           <div className="review-section">
//                             <label>Your Review (Optional)</label>
//                             <textarea
//                               placeholder="Share your experience..."
//                               value={ratingReview}
//                               onChange={(e) => setRatingReview(e.target.value)}
//                               className="review-textarea"
//                               rows="3"
//                             />
//                           </div>

//                           <div className="image-upload-section">
//                             <label>Add Photos (Optional)</label>
//                             <div className="file-upload-area">
//                               <input
//                                 type="file"
//                                 multiple
//                                 accept="image/*"
//                                 onChange={(e) =>
//                                   handleImageUpload(
//                                     e,
//                                     setRatingImages,
//                                     setRatingPreviewUrls,
//                                   )
//                                 }
//                                 className="file-input"
//                               />
//                               <div className="upload-hint">
//                                 <FaCamera className="upload-icon" />
//                                 <div className="upload-text">
//                                   <div className="upload-title">
//                                     Click to upload images
//                                   </div>
//                                   <div className="upload-subtitle">
//                                     PNG, JPG, WEBP up to 10MB
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>

//                             {ratingPreviewUrls.length > 0 && (
//                               <div className="preview-images">
//                                 {ratingPreviewUrls.map((url, idx) => (
//                                   <div
//                                     key={idx}
//                                     className="preview-image-wrapper"
//                                   >
//                                     <img src={url} alt={`Preview ${idx + 1}`} />
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         handleRemoveImage(
//                                           idx,
//                                           setRatingImages,
//                                           setRatingPreviewUrls,
//                                         )
//                                       }
//                                       aria-label={`Remove image ${idx + 1}`}
//                                     >
//                                       ✖
//                                     </button>
//                                   </div>
//                                 ))}
//                               </div>
//                             )}
//                           </div>

//                           <button
//                             className={`submit-rating-btn ${
//                               !rating ? 'disabled' : ''
//                             }`}
//                             onClick={handleSubmitRating}
//                             disabled={!rating || isSubmittingRating}
//                           >
//                             {isSubmittingRating
//                               ? 'Submitting...'
//                               : 'Submit Review'}
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}
//         </Modal.Body>
//       </Modal>

//       {/* View Proposal Modal */}
//       <Modal
//         show={showProposalModal}
//         onHide={() => {
//           setShowProposalModal(false);
//           setViewingProposal(null);
//         }}
//         centered
//         size="lg"
//         className="proposal-view-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             Proposal from {viewingProposal?.artisan_name}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {loadingProposal ? (
//             <div className="proposal-loading">
//               <div className="spinner"></div>
//               <p>Loading proposal details...</p>
//             </div>
//           ) : viewingProposal ? (
//             <div className="proposal-details">
//               <div className="proposal-card">
//                 <div className="proposal-header">
//                   <div className="proposal-badge">
//                     <FaFileAlt />
//                     <span>Proposal Details</span>
//                   </div>
//                   <div
//                     className={`proposal-status ${viewingProposal.is_selected ? 'accepted' : 'pending'}`}
//                   >
//                     {viewingProposal.is_selected
//                       ? 'Accepted ✓'
//                       : 'Pending Review'}
//                   </div>
//                 </div>

//                 <div className="proposal-info-grid">
//                   <div className="info-item">
//                     <FaMoneyBillWave className="info-icon" />
//                     <div>
//                       <label>Proposed Amount</label>
//                       <p className="amount">
//                         KSh{' '}
//                         {parseFloat(
//                           viewingProposal.proposed_price || 0,
//                         ).toLocaleString()}
//                       </p>
//                     </div>
//                   </div>

//                   <div className="info-item">
//                     <FaCalendar className="info-icon" />
//                     <div>
//                       <label>Completion Date</label>
//                       <p>
//                         {viewingProposal.proposed_date_of_completion
//                           ? new Date(
//                               viewingProposal.proposed_date_of_completion,
//                             ).toLocaleDateString()
//                           : 'Not specified'}
//                       </p>
//                     </div>
//                   </div>

//                   <div className="info-item">
//                     <FaClock className="info-icon" />
//                     <div>
//                       <label>Submitted On</label>
//                       <p>
//                         {viewingProposal.created_at
//                           ? new Date(
//                               viewingProposal.created_at,
//                             ).toLocaleString()
//                           : 'Date not available'}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {viewingProposal.note && (
//                   <div className="proposal-message">
//                     <label>Message from Artisan</label>
//                     <div className="message-content">
//                       <FaEnvelope className="message-icon" />
//                       <p>{viewingProposal.note}</p>
//                     </div>
//                   </div>
//                 )}

//                 {viewingProposal.is_selected && (
//                   <div className="proposal-selected-note">
//                     <FaCheckCircle />
//                     <span>
//                       This proposal has been selected for the project!
//                     </span>
//                   </div>
//                 )}

//                 {!viewingProposal.is_selected && (
//                   <div className="proposal-actions">
//                     <button
//                       className="select-proposal-btn"
//                       onClick={async () => {
//                         await handleSelectArtisan({
//                           proposal_id: viewingProposal.id,
//                           artisan_name: viewingProposal.artisan_name,
//                           has_proposal: true,
//                         });
//                         setShowProposalModal(false);
//                         setViewingProposal(null);
//                       }}
//                       disabled={acceptingProposal}
//                     >
//                       <FaCheckCircle />
//                       {acceptingProposal
//                         ? 'Selecting...'
//                         : 'Select This Proposal'}
//                     </button>

//                     <button
//                       className="message-artisan-btn"
//                       onClick={async () => {
//                         setShowProposalModal(false);
//                         setViewingProposal(null);

//                         try {
//                           const proposalsRes = await serverUrlAuth.get(
//                             `proposals/proposals-list/${viewRequest?.id}/`,
//                           );

//                           if (proposalsRes.data.length > 0) {
//                             const proposal = proposalsRes.data.find(
//                               (p) => p.id === viewingProposal.id,
//                             );

//                             if (proposal) {
//                               navigate(
//                                 `/messages?proposal=${proposal.id}&project=${viewRequest?.title}&artisan=${viewingProposal.artisan_name}`,
//                               );
//                             } else {
//                               toast.error('Unable to open chat');
//                             }
//                           } else {
//                             toast.error('No proposal found');
//                           }
//                         } catch (error) {
//                           console.error('Error opening chat:', error);
//                           toast.error('Failed to open chat');
//                         }
//                       }}
//                     >
//                       <FaComments /> Message Artisan
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           ) : (
//             <div className="proposal-error">
//               <FaTimes className="error-icon" />
//               <p>Failed to load proposal details</p>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => {
//               setShowProposalModal(false);
//               setViewingProposal(null);
//             }}
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Modal */}
//       <Modal
//         show={!!editRequest}
//         onHide={() => setEditRequest(null)}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Project Request</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {editRequest && (
//             <div className="edit-modal-content">
//               <form className="edit-form">
//                 <div className="form-group">
//                   <label>Project Title</label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={projectData.title}
//                     onChange={(e) =>
//                       setProjectData((prev) => ({
//                         ...prev,
//                         title: e.target.value,
//                       }))
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     value={projectData.description}
//                     onChange={(e) =>
//                       setProjectData((prev) => ({
//                         ...prev,
//                         description: e.target.value,
//                       }))
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Budget (KSh)</label>
//                   <input
//                     type="number"
//                     name="budget"
//                     value={projectData.budget}
//                     onChange={(e) =>
//                       setProjectData((prev) => ({
//                         ...prev,
//                         budget: e.target.value,
//                       }))
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Location</label>
//                   <input
//                     type="text"
//                     name="location"
//                     value={projectData.location}
//                     onChange={(e) =>
//                       setProjectData((prev) => ({
//                         ...prev,
//                         location: e.target.value,
//                       }))
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Preferred Deadline</label>
//                   <input
//                     type="date"
//                     name="deadline"
//                     value={projectData.deadline}
//                     onChange={(e) =>
//                       setProjectData((prev) => ({
//                         ...prev,
//                         deadline: e.target.value,
//                       }))
//                     }
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Upload New Images</label>
//                   <input
//                     type="file"
//                     multiple
//                     accept="image/*"
//                     onChange={(e) =>
//                       handleImageUpload(e, setNewImages, setPreviewUrls)
//                     }
//                   />
//                 </div>

//                 {previewUrls.length > 0 && (
//                   <div className="image-preview-grid-edit">
//                     {previewUrls.map((url, idx) => (
//                       <div key={idx} className="image-card edit-image">
//                         <img
//                           src={url}
//                           alt="Preview"
//                           className="thumbnail-edit-image"
//                         />
//                         <button
//                           type="button"
//                           className="remove-btn"
//                           onClick={() =>
//                             handleRemoveImage(idx, setNewImages, setPreviewUrls)
//                           }
//                         >
//                           ✖
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </form>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setEditRequest(null)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleEditProject}>
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Modal */}
//       <Modal
//         show={!!deleteRequest}
//         onHide={() => setDeleteRequest(null)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Request</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {deleteRequest && (
//             <p>
//               Are you sure you want to delete{' '}
//               <strong>{deleteRequest.title}</strong>?
//             </p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDeleteRequest(null)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={handleDeleteProject}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Portfolio Modal */}
//       <Modal
//         show={!!portfolioModal}
//         onHide={closePortfolio}
//         centered
//         size="xl"
//         className="portfolio-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{portfolioModal?.artisan_name}'s Portfolio</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="portfolio-content">
//             <div className="artisan-profile">
//               <div className="profile-header">
//                 <div className="artisan-avatar">
//                   <img
//                     src={portfolioModal?.artisan_avatar}
//                     alt={portfolioModal?.artisan_name}
//                   />
//                 </div>
//                 <div className="profile-info">
//                   <h3>{portfolioModal?.artisan_name}</h3>
//                   <div className="rating-display">
//                     <div className="stars">
//                       {[...Array(5)].map((_, i) => (
//                         <FaStar
//                           key={i}
//                           className="star"
//                           color={
//                             i < Math.round(portfolioModal?.client_rating || 0)
//                               ? '#ffc107'
//                               : '#e4e5e9'
//                           }
//                         />
//                       ))}
//                     </div>
//                     <span className="rating-text">
//                       {portfolioModal?.client_rating || '0'}/5
//                     </span>
//                   </div>
//                   <span className="specialization">
//                     {portfolioModal?.specialization || 'Furniture Artisan'}
//                   </span>
//                 </div>
//               </div>
//               <div className="artisan-bio">
//                 <p
//                   className={`bio-content ${
//                     expandedBios[portfolioModal?.artisan_id]
//                       ? 'expanded'
//                       : 'collapsed'
//                   }`}
//                 >
//                   {portfolioModal?.bio || 'No bio available'}
//                 </p>
//                 <button
//                   className={`read-more-btn ${
//                     expandedBios[portfolioModal?.artisan_id] ? 'expanded' : ''
//                   }`}
//                   onClick={() => toggleBio(portfolioModal?.artisan_id)}
//                 >
//                   {expandedBios[portfolioModal?.artisan_id]
//                     ? 'Read Less'
//                     : 'Read More'}
//                 </button>
//               </div>
//             </div>

//             <div className="portfolio-stats">
//               <div className="stat-card">
//                 <div className="stat-number">
//                   {portfolioModal?.projects_completed || '0'}
//                 </div>
//                 <div className="stat-label">Projects Completed</div>
//               </div>
//               <div className="stat-card">
//                 <div className="stat-number">
//                   {portfolioModal?.years_of_experience || '0'}+
//                 </div>
//                 <div className="stat-label">Years Experience</div>
//               </div>
//             </div>

//             <div className="portfolio-projects-section">
//               <div className="section-title">
//                 <h4>Featured Projects</h4>
//                 <p>Explore the artisan's completed work and craftsmanship</p>
//               </div>
//               {portfolioModal?.portfolio_items?.length > 0 ? (
//                 <div className="projects-grid">
//                   {portfolioModal.portfolio_items.map((project) => (
//                     <div
//                       key={project.id}
//                       className="portfolio-project-card-requests"
//                     >
//                       <div className="carousel-container">
//                         {project.images?.length > 0 ? (
//                           <div className="carousel-wrapper">
//                             {project.images?.map((img, index) => (
//                               <img
//                                 key={img.id}
//                                 src={img.image}
//                                 alt={`${project.title} ${index + 1}`}
//                                 className={`carousel-image ${
//                                   index === (carouselIndex[project.id] || 0)
//                                     ? 'active-image'
//                                     : 'inactive-image'
//                                 }`}
//                               />
//                             ))}
//                           </div>
//                         ) : (
//                           <div className="image-placeholder">
//                             <FaImage className="placeholder-icon" />
//                             <span className="placeholder-text">
//                               No images available
//                             </span>
//                           </div>
//                         )}
//                         <button
//                           className="carousel-btn left"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handlePrev(project.id, project.images.length);
//                           }}
//                         >
//                           ‹
//                         </button>
//                         <button
//                           className="carousel-btn right"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleNext(project.id, project.images.length);
//                           }}
//                         >
//                           ›
//                         </button>
//                         {project.images?.length > 1 && (
//                           <div className="carousel-indicators">
//                             {project.images.map((_, index) => (
//                               <div
//                                 key={index}
//                                 className={`indicator ${
//                                   index === (carouselIndex[project.id] || 0)
//                                     ? 'active'
//                                     : ''
//                                 }`}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setCarouselIndex((prev) => ({
//                                     ...prev,
//                                     [project.id]: index,
//                                   }));
//                                 }}
//                               />
//                             ))}
//                           </div>
//                         )}
//                       </div>
//                       <div className="project-info">
//                         <h5>{project.title}</h5>
//                         <div className="project-description">
//                           <p
//                             className={`description-content ${
//                               expandedDescriptions[project.id]
//                                 ? 'expanded'
//                                 : 'collapsed'
//                             }`}
//                           >
//                             {project.description}
//                           </p>
//                           {project.description &&
//                             project.description.length > 100 && (
//                               <button
//                                 className={`read-more-btn ${
//                                   expandedDescriptions[project.id]
//                                     ? 'expanded'
//                                     : ''
//                                 }`}
//                                 onClick={() => toggleDescription(project.id)}
//                               >
//                                 {expandedDescriptions[project.id]
//                                   ? 'Read Less'
//                                   : 'Read More'}
//                               </button>
//                             )}
//                         </div>
//                         <div className="project-bottom-meta">
//                           <div className="project-rating">
//                             <FaStar color="#ffc107" />
//                             <span>{project.rating || '0'}</span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="portfolio-empty-state">
//                   <div className="empty-icon">🎨</div>
//                   <h4>No Projects Yet</h4>
//                   <p>
//                     This artisan hasn't added any projects to their portfolio
//                     yet.
//                   </p>
//                 </div>
//               )}
//             </div>

//             <div className="skills-section">
//               <h5>Specializations & Skills</h5>
//               <div className="skills-grid">
//                 {portfolioModal?.skills?.length > 0 ? (
//                   portfolioModal.skills.map((skill, index) => (
//                     <span key={index} className="skill-tag">
//                       {skill}
//                     </span>
//                   ))
//                 ) : (
//                   <>
//                     <span className="skill-tag">Woodworking</span>
//                     <span className="skill-tag">Custom Furniture</span>
//                     <span className="skill-tag">Carpentry</span>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={closePortfolio}>
//             Close Portfolio
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Confirmation Modal for Selecting Artisan */}
//       <Modal
//         show={showConfirmModal}
//         onHide={() => {
//           setShowConfirmModal(false);
//           setSelectedMatchForConfirm(null);
//         }}
//         centered
//         className="confirm-select-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Artisan Selection</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedMatchForConfirm && (
//             <div className="confirmation-content">
//               <div className="confirmation-icon">
//                 <FaCheckCircle className="warning-icon" />
//               </div>
//               <p className="confirmation-question">
//                 Are you sure you want to select{' '}
//                 <strong>{selectedMatchForConfirm.artisan_name}</strong> for this
//                 project?
//               </p>

//               <div className="confirmation-details">
//                 <div className="detail-row">
//                   <span className="detail-label">Project:</span>
//                   <span className="detail-value">{viewRequest?.title}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">Artisan:</span>
//                   <span className="detail-value">
//                     {selectedMatchForConfirm.artisan_name}
//                   </span>
//                 </div>
//                 <div className="detail-row highlight">
//                   <span className="detail-label">Agreed Amount:</span>
//                   <span className="detail-value amount">
//                     KSh{' '}
//                     {/* Show final_agreed_amount if available (after negotiation), otherwise show proposed_price */}
//                     {selectedMatchForConfirm.final_agreed_amount
//                       ? parseFloat(
//                           selectedMatchForConfirm.final_agreed_amount,
//                         ).toLocaleString()
//                       : parseFloat(
//                           selectedMatchForConfirm.proposed_price,
//                         ).toLocaleString()}
//                   </span>
//                 </div>
//                 {/* Show negotiation badge if this is a negotiated amount */}
//                 {selectedMatchForConfirm.final_agreed_amount && (
//                   <div className="negotiation-badge">
//                     <span>✓ Negotiated Price</span>
//                   </div>
//                 )}
//               </div>

//               <div className="confirmation-warning">
//                 <p>
//                   ⚠️ <strong>Note:</strong> Once you select this artisan:
//                 </p>
//                 <ul>
//                   <li>
//                     Other proposals for this project will be automatically
//                     declined
//                   </li>
//                   <li>The artisan will be notified and project will start</li>
//                   <li>
//                     You will be able to communicate with the artisan through
//                     messages
//                   </li>
//                   <li>This action cannot be undone</li>
//                 </ul>
//               </div>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => {
//               setShowConfirmModal(false);
//               setSelectedMatchForConfirm(null);
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             onClick={confirmSelectArtisan}
//             disabled={acceptingProposal}
//             className="confirm-select-btn"
//           >
//             {acceptingProposal ? (
//               <>
//                 <FaSpinner className="spinning" /> Selecting...
//               </>
//             ) : (
//               <>
//                 <FaCheckCircle /> Yes, Select Artisan
//               </>
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default withAuth(MyRequests, 'client');

import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import withAuth from '../../auth/WithAuth';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';
import {
  FaStar,
  FaCamera,
  FaImage,
  FaUserCircle,
  FaBriefcase,
  FaCheckCircle,
  FaClock,
  FaFileAlt,
  FaTimes,
  FaMoneyBillWave,
  FaCalendar,
  FaEnvelope,
  FaComments,
  FaSpinner,
  FaRocket,
  FaProjectDiagram,
  FaHandshake,
} from 'react-icons/fa';
import './myrequests.scss';
import FurnitureNavbar from '../../../components/layout/Nav';

const MyRequests = () => {
  // ========== STATE MANAGEMENT ==========
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [matchedArtisans, setMatchedArtisans] = useState([]);
  const [loadingMatches, setLoadingMatches] = useState(false);
  const [viewRequest, setViewRequest] = useState(null);
  const [editRequest, setEditRequest] = useState(null);
  const [deleteRequest, setDeleteRequest] = useState(null);
  const [portfolioModal, setPortfolioModal] = useState(null);
  const [showProposalModal, setShowProposalModal] = useState(false);
  const [viewingProposal, setViewingProposal] = useState(null);
  const [loadingProposal, setLoadingProposal] = useState(false);
  const [acceptingProposal, setAcceptingProposal] = useState(false);
  const [autoOpenProjectId, setAutoOpenProjectId] = useState(null);
  const [showPriceAgreedMessage, setShowPriceAgreedMessage] = useState(false);
  const [selectedArtisanId, setSelectedArtisanId] = useState(null);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [ratingReview, setRatingReview] = useState('');
  const [ratingImages, setRatingImages] = useState([]);
  const [ratingPreviewUrls, setRatingPreviewUrls] = useState([]);
  const [existingRating, setExistingRating] = useState(null);
  const [isSubmittingRating, setIsSubmittingRating] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const [carouselIndex, setCarouselIndex] = useState({});
  const [expandedBios, setExpandedBios] = useState({});
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedMatchForConfirm, setSelectedMatchForConfirm] = useState(null);
  const [projectData, setProjectData] = useState({
    title: '',
    description: '',
    budget: '',
    location: '',
    deadline: '',
  });
  const [newImages, setNewImages] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);

  const navigate = useNavigate();

  // ========== API FUNCTIONS ==========
  const fetchClientProjects = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await serverUrlAuth.get('projects/client-projects/');
      setRequests(res.data);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to fetch project requests.');
    } finally {
      setLoading(false);
    }
  };

  const fetchMatchedArtisans = async (projectId) => {
    setLoadingMatches(true);
    try {
      const res = await serverUrlAuth.get(
        `projects/client/projects/${projectId}/matches/`,
      );
      console.log('Matched artisans response:', res.data);
      setMatchedArtisans(res.data);
    } catch (err) {
      console.error('Error fetching matched artisans:', err);
      toast.error('Failed to load matched artisans');
    } finally {
      setLoadingMatches(false);
    }
  };

  const fetchProposalDetails = async (proposalId) => {
    setLoadingProposal(true);
    try {
      const response = await serverUrlAuth.get(
        `proposals/proposal-detail/${proposalId}/`,
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching proposal details:', error);
      toast.error('Failed to load proposal details');
      return null;
    } finally {
      setLoadingProposal(false);
    }
  };

  const handleViewProposal = async (match) => {
    if (!match.has_proposal || !match.proposal_id) {
      toast.error('No proposal found for this artisan');
      return;
    }

    const proposal = await fetchProposalDetails(match.proposal_id);
    if (proposal) {
      setViewingProposal({
        ...proposal,
        artisan_name: match.artisan_name,
        artisan_id: match.artisan_id,
      });
      setShowProposalModal(true);
    }
  };

  const fetchPortfolioData = async (artisanId) => {
    try {
      const response = await serverUrlAuth.get(
        `portfolio/artisan-portfolio/${artisanId}/`,
      );
      return response.data;
    } catch (err) {
      console.error('Error fetching portfolio:', err);
    }
  };

  const fetchRating = async () => {
    if (!viewRequest?.id) return;
    try {
      const res = await serverUrlAuth.get(
        `reviews/project-review/${viewRequest.id}/`,
      );
      if (res.data) {
        setExistingRating(res.data);
        setRating(res.data.score || 0);
        setRatingReview(res.data.review || '');
        setRatingPreviewUrls(
          res.data.images?.map((img) => img.image_url) || [],
        );
      }
    } catch (err) {
      if (err.response?.status !== 404) {
        toast.error('Failed to fetch rating');
      }
    }
  };

  // ========== PROJECT MANAGEMENT FUNCTIONS ==========
  const handleDeleteProject = async () => {
    if (!deleteRequest) return;
    try {
      await serverUrlAuth.delete(
        `projects/client-project/${deleteRequest.id}/`,
      );
      toast.success(`Project "${deleteRequest.title}" deleted`);
      setRequests((prev) => prev.filter((r) => r.id !== deleteRequest.id));
      setDeleteRequest(null);
    } catch (err) {
      toast.error('Failed to delete project');
    }
  };

  const handleEditProject = async () => {
    if (!editRequest) return;
    try {
      const formData = new FormData();
      Object.entries(projectData).forEach(([key, value]) =>
        formData.append(key, value),
      );
      newImages.forEach((file) => formData.append('images', file));

      await serverUrlAuth.patch(
        `projects/client-project/${editRequest.id}/`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      toast.success(`Project "${projectData.title}" updated`);
      setEditRequest(null);
      resetEditForm();
      fetchClientProjects();
    } catch (err) {
      toast.error('Failed to update project');
    }
  };

  // ========== RATING FUNCTIONS ==========
  const handleSubmitRating = async () => {
    if (!rating || !viewRequest?.id) {
      toast.error('Please select a rating');
      return;
    }

    setIsSubmittingRating(true);
    try {
      const formData = new FormData();
      formData.append('score', rating);
      formData.append('review', ratingReview);
      ratingImages.forEach((file) => formData.append('images', file));

      const res = await serverUrlAuth.post(
        `reviews/project-review/${viewRequest.id}/create/`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      toast.success('Review submitted successfully!');
      setExistingRating(res.data);
      resetRatingForm();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to submit rating');
    } finally {
      setIsSubmittingRating(false);
    }
  };

  // ========== UI HANDLERS ==========
  const handleSelectArtisan = (match) => {
    if (!match.has_proposal) {
      toast.error('No proposal found for this artisan');
      return;
    }

    setSelectedMatchForConfirm(match);
    setShowConfirmModal(true);
  };

  const confirmSelectArtisan = async () => {
    if (!selectedMatchForConfirm) return;

    setAcceptingProposal(true);
    try {
      await serverUrlAuth.patch(
        `proposals/${selectedMatchForConfirm.proposal_id}/select/`,
      );
      toast.success(
        `You have selected ${selectedMatchForConfirm.artisan_name} for this project!`,
      );
      setViewRequest(null);
      fetchClientProjects();
      setShowConfirmModal(false);
      setSelectedMatchForConfirm(null);
    } catch (err) {
      console.error('Error selecting artisan:', err);
      toast.error('Failed to select artisan');
    } finally {
      setAcceptingProposal(false);
    }
  };

  const handleViewProject = async (project) => {
    setViewRequest(project);
    if (project.status.toLowerCase() === 'open') {
      await fetchMatchedArtisans(project.id);
    }
    if (project.status.toLowerCase() === 'completed') {
      fetchRating();
    }
  };

  const openPortfolio = async (artisanId, artisanName) => {
    const portfolioData = await fetchPortfolioData(artisanId);
    setPortfolioModal({ ...portfolioData, artisan_name: artisanName });
    setViewRequest(null);
  };

  const closePortfolio = () => setPortfolioModal(null);

  const openEditModal = (request) => {
    setEditRequest(request);
    setProjectData({
      title: request.title || '',
      description: request.description || '',
      budget: request.budget || '',
      location: request.location || '',
      deadline: request.deadline?.split('T')[0] || '',
    });
    setNewImages([]);
    setPreviewUrls([]);
  };

  const toggleBio = (artisanId) => {
    setExpandedBios((prev) => ({
      ...prev,
      [artisanId]: !prev[artisanId],
    }));
  };

  const toggleDescription = (projectId) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  // ========== UTILITY FUNCTIONS ==========
  const handleImageUpload = (e, setImages, setPreviews) => {
    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
    setPreviews((prev) => [
      ...prev,
      ...files.map((file) => URL.createObjectURL(file)),
    ]);
  };

  const handleRemoveImage = (index, setImages, setPreviews) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const resetRatingForm = () => {
    setRating(0);
    setRatingReview('');
    setRatingImages([]);
    setRatingPreviewUrls([]);
  };

  const resetEditForm = () => {
    setNewImages([]);
    setPreviewUrls([]);
  };

  // ========== UI HELPERS ==========
  const shouldShowEditDelete = (status) =>
    ['open', 'pending'].includes(status.toLowerCase());

  const normalize = (str) => str.toLowerCase().replace(/\s+/g, '');

  const filteredRequests =
    filter === 'all'
      ? requests
      : requests.filter((r) => normalize(r.status) === normalize(filter));

  const handleNext = (projectId, totalImages) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [projectId]: ((prev[projectId] || 0) + 1) % totalImages,
    }));
  };

  const handlePrev = (projectId, totalImages) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [projectId]:
        (prev[projectId] || 0) === 0
          ? totalImages - 1
          : (prev[projectId] || 0) - 1,
    }));
  };

  const getTierBadgeClass = (tier) => {
    switch (tier?.toLowerCase()) {
      case 'bronze':
        return 'tier-bronze';
      case 'silver':
        return 'tier-silver';
      case 'gold':
        return 'tier-gold';
      default:
        return 'tier-bronze';
    }
  };

  const getTierIcon = (tier) => {
    switch (tier?.toLowerCase()) {
      case 'bronze':
        return '🥉';
      case 'silver':
        return '🥈';
      case 'gold':
        return '🥇';
      default:
        return '🥉';
    }
  };

  // ========== EFFECTS ==========
  useEffect(() => {
    const projectId = sessionStorage.getItem('openProjectMatches');
    const showMessage = sessionStorage.getItem('showPriceAgreedMessage');
    const artisanId = sessionStorage.getItem('selectedArtisanId');

    if (projectId) {
      setAutoOpenProjectId(projectId);
      if (showMessage) {
        setShowPriceAgreedMessage(true);
        setTimeout(() => setShowPriceAgreedMessage(false), 5000);
      }
      if (artisanId) {
        setSelectedArtisanId(artisanId);
      }
      sessionStorage.removeItem('openProjectMatches');
      sessionStorage.removeItem('showPriceAgreedMessage');
      sessionStorage.removeItem('selectedArtisanId');
    }
  }, []);

  useEffect(() => {
    if (autoOpenProjectId && requests.length > 0) {
      const project = requests.find(
        (r) => r.id.toString() === autoOpenProjectId.toString(),
      );
      if (project && project.status.toLowerCase() === 'open') {
        handleViewProject(project);
        setAutoOpenProjectId(null);
      }
    }
  }, [requests, autoOpenProjectId]);

  useEffect(() => {
    fetchClientProjects();
  }, []);

  useEffect(() => {
    if (viewRequest) {
      setActiveImage(0);
      if (viewRequest.status.toLowerCase() === 'open') {
        fetchMatchedArtisans(viewRequest.id);
      }
      if (viewRequest.status.toLowerCase() === 'completed') {
        fetchRating();
      } else {
        resetRatingForm();
        setExistingRating(null);
      }
    }
  }, [viewRequest]);

  if (loading) {
    return (
      <div className="modern-dashboard">
        <div className="dashboard-loader">
          <div className="wooden-spinner"></div>
          <p>Crafting your experience...</p>
        </div>
      </div>
    );
  }

  // ========== RENDER ==========
  return (
    <>
      <FurnitureNavbar />
      <div className="modern-dashboard">
        {/* Hero Section */}
        <section className="hero-craftsmanship">
          <div className="hero-pattern"></div>
          <div className="hero-content-modern">
            <div className="welcome-badge">
              <span className="badge-icon">📋</span>
              <span>My Project Requests</span>
            </div>
            <h1 className="hero-title">
              <span className="gradient-text">Track & Manage</span>
              <span className="hero-accent">Your Projects</span>
            </h1>
            <p className="hero-subtitle">
              Keep track of all your custom furniture and design requests in one
              place. Monitor progress, review proposals, and connect with
              skilled artisans.
            </p>
            <div className="hero-actions">
              <Link to="/new-project" className="btn-primary-custom">
                <FaRocket /> Create New Project
              </Link>
            </div>
          </div>
        </section>

        {/* Quick Stats Dashboard */}
        <div className="stats-dashboard">
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#67320020', color: '#673200' }}
            >
              <FaProjectDiagram />
            </div>
            <div className="stat-content">
              <h3>
                {requests.filter((r) => r.status?.toLowerCase() === 'open')
                  .length || 0}
              </h3>
              <p>Open Projects</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#4caf5020', color: '#4caf50' }}
            >
              <FaCheckCircle />
            </div>
            <div className="stat-content">
              <h3>
                {requests.filter(
                  (r) => r.status?.toLowerCase() === 'in-progress',
                ).length || 0}
              </h3>
              <p>In Progress</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#ff980020', color: '#ff9800' }}
            >
              <FaCheckCircle />
            </div>
            <div className="stat-content">
              <h3>
                {requests.filter((r) => r.status?.toLowerCase() === 'completed')
                  .length || 0}
              </h3>
              <p>Completed</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#9c27b020', color: '#9c27b0' }}
            >
              <FaHandshake />
            </div>
            <div className="stat-content">
              <h3>
                {requests.reduce(
                  (sum, r) => sum + (r.proposals_count || 0),
                  0,
                ) || 0}
              </h3>
              <p>Total Proposals</p>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="filter-section-modern">
          <div className="filter-tabs">
            {['all', 'open', 'in-progress', 'completed'].map((status) => (
              <button
                key={status}
                className={`filter-tab ${filter === status ? 'active' : ''}`}
                onClick={() => setFilter(status)}
              >
                {status === 'all'
                  ? 'All Projects'
                  : status === 'in-progress'
                    ? 'In Progress'
                    : status.charAt(0).toUpperCase() + status.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="projects-showcase">
          <div className="section-header-modern">
            <h2>
              <span className="header-icon">📋</span>
              Your Projects
              <span className="header-line"></span>
            </h2>
          </div>

          {error ? (
            <div className="error-state">
              <p>{error}</p>
              <button onClick={fetchClientProjects} className="retry-btn">
                Try Again
              </button>
            </div>
          ) : filteredRequests.length === 0 ? (
            <div className="empty-state-modern">
              <div className="empty-icon">📭</div>
              <h3>No projects found</h3>
              <p>
                {requests.length === 0
                  ? "You haven't created any projects yet."
                  : `No ${filter !== 'all' ? filter : ''} projects found.`}
              </p>
              {requests.length === 0 && (
                <Link to="/new-project" className="btn-primary-custom">
                  <FaRocket /> Create Your First Project
                </Link>
              )}
            </div>
          ) : (
            <div className="projects-grid-modern">
              {filteredRequests.map((req) => (
                <div key={req.id} className="project-card-modern">
                  {/* Image Section at the top */}
                  <div className="card-image-section">
                    <img
                      src={
                        req.images?.length
                          ? req.images[0].image_url || req.images[0].image
                          : 'https://via.placeholder.com/400x200?text=No+Image'
                      }
                      alt={req.title}
                      className="card-image"
                    />
                    <span
                      className={`status-badge-overlay ${req.status?.toLowerCase().replace(' ', '-')}`}
                    >
                      {req.status}
                    </span>
                    {req.proposals_count > 0 &&
                      req.status?.toLowerCase() === 'open' && (
                        <span className="proposals-badge-overlay">
                          💼 {req.proposals_count}{' '}
                          {req.proposals_count === 1 ? 'proposal' : 'proposals'}
                        </span>
                      )}
                  </div>

                  {/* Card Content */}
                  <div className="card-content-section">
                    <div className="project-header">
                      <div className="project-title-section">
                        <h3>{req.title}</h3>
                      </div>
                      <div className="project-budget">
                        KSh{' '}
                        {parseFloat(
                          req.agreed_cost || req.budget || 0,
                        ).toLocaleString()}
                      </div>
                    </div>

                    <div className="project-details-preview">
                      <p className="project-description-preview">
                        {req.description?.substring(0, 80)}
                        {req.description?.length > 80 ? '...' : ''}
                      </p>
                      <div className="project-meta">
                        <span className="meta-item">
                          <FaCalendar /> Due:{' '}
                          {new Date(req.deadline).toLocaleDateString()}
                        </span>
                      </div>
                    </div>

                    <div className="project-footer-my-projects">
                      <button
                        className="project-action"
                        onClick={() => handleViewProject(req)}
                      >
                        {req.status?.toLowerCase() === 'open'
                          ? 'View Artisan Matches →'
                          : req.status?.toLowerCase() === 'completed'
                            ? existingRating
                              ? 'View Review →'
                              : 'Rate Project →'
                            : 'View Details →'}
                      </button>
                      {shouldShowEditDelete(req.status) && (
                        <div className="action-buttons">
                          <button
                            className="edit-action"
                            onClick={() => openEditModal(req)}
                          >
                            Edit
                          </button>
                          <button
                            className="delete-action"
                            onClick={() => setDeleteRequest(req)}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Project Details Modal with Matched Artisans */}
        <Modal
          show={!!viewRequest}
          onHide={() => setViewRequest(null)}
          centered
          size="xl"
          className="project-details-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {viewRequest?.status?.toLowerCase() === 'completed'
                ? 'Rate Project'
                : viewRequest?.status?.toLowerCase() === 'open'
                  ? 'Matched Artisans'
                  : 'Project Details'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {viewRequest && (
              <div className="modal-two-column-layout">
                {/* Left Side - Images */}
                <div className="modal-left-side">
                  <div className="image-carousel">
                    <div className="main-image-container">
                      <img
                        src={
                          viewRequest.images?.length
                            ? viewRequest.images[activeImage].image
                            : 'https://via.placeholder.com/400x300?text=No+Image'
                        }
                        alt={viewRequest.title}
                        className="main-image"
                      />
                    </div>
                    {viewRequest.images?.length > 1 && (
                      <div className="thumbnail-strip">
                        {viewRequest.images.map((img, idx) => (
                          <img
                            key={idx}
                            src={img.image}
                            alt={`Thumb ${idx + 1}`}
                            className={`thumbnail ${activeImage === idx ? 'active' : ''}`}
                            onClick={() => setActiveImage(idx)}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Side - Content */}
                <div className="modal-right-side">
                  <div className="content-section">
                    <h3 className="project-title">{viewRequest.title}</h3>

                    <div className="project-details">
                      <p>
                        <strong>Status:</strong> {viewRequest.status}
                      </p>
                      {!viewRequest.agreed_cost ? (
                        <p>
                          <strong>Budget:</strong> KSh{' '}
                          {parseFloat(viewRequest.budget).toLocaleString()}
                        </p>
                      ) : (
                        <p>
                          <strong>Agreed Cost:</strong> KSh{' '}
                          {parseFloat(viewRequest.agreed_cost).toLocaleString()}
                        </p>
                      )}
                      <p>
                        <strong>Deadline:</strong>{' '}
                        {new Date(viewRequest.deadline).toLocaleDateString()}
                      </p>
                      <p>
                        <strong>Location:</strong> {viewRequest.location}
                      </p>
                      <div className="description-section">
                        <strong>Description:</strong>
                        <p>{viewRequest.description}</p>
                      </div>
                    </div>

                    {/* Matched Artisans Section for Open Projects */}
                    {viewRequest.status?.toLowerCase() === 'open' && (
                      <div className="matched-artisans-section">
                        <div className="section-header">
                          <h4>
                            🤝 Matched Artisans ({matchedArtisans.length})
                          </h4>
                          <p className="match-info">
                            Based on your budget of KSh{' '}
                            {parseFloat(viewRequest.budget).toLocaleString()},
                            we've found skilled artisans who match your
                            requirements.
                          </p>
                        </div>

                        {loadingMatches ? (
                          <div className="loading-matches">
                            <div className="spinner"></div>
                            <p>Finding the best artisans for you...</p>
                          </div>
                        ) : matchedArtisans.length === 0 ? (
                          <div className="no-matches">
                            <div className="no-matches-icon">🔍</div>
                            <h5>No matches found yet</h5>
                            <p>
                              We're still looking for artisans who match your
                              requirements. Check back soon!
                            </p>
                          </div>
                        ) : (
                          <div className="matched-artisans-list">
                            {matchedArtisans.map((match) => (
                              <div
                                key={match.id}
                                className="matched-artisan-card"
                              >
                                <div className="artisan-header">
                                  <div className="artisan-avatar">
                                    <FaUserCircle className="avatar-placeholder" />
                                  </div>
                                  <div className="artisan-info">
                                    <h5>
                                      {match.artisan_name ||
                                        `Artisan ${match.artisan_id}`}
                                    </h5>
                                    <div className="artisan-meta">
                                      <span
                                        className={`tier-badge ${getTierBadgeClass(match.tier)}`}
                                      >
                                        {getTierIcon(match.tier)}{' '}
                                        {match.tier?.toUpperCase() || 'BRONZE'}
                                      </span>
                                      <div className="rating">
                                        <FaStar className="star-icon" />
                                        <span>
                                          {match.average_rating || 'New'}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="match-status">
                                    {match.has_proposal ? (
                                      <span
                                        className={`proposal-status-badge ${match.proposal_selected ? 'accepted' : 'pending'}`}
                                      >
                                        {match.proposal_selected
                                          ? '✅ Selected'
                                          : '📝 Proposal Received'}
                                      </span>
                                    ) : (
                                      <span className="proposal-status-badge no-proposal">
                                        <FaClock /> Waiting for Proposal
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="artisan-bio-preview">
                                  <p>
                                    {match.bio ||
                                      'Skilled artisan ready to work on your project.'}
                                  </p>
                                </div>

                                <div className="artisan-actions">
                                  <button
                                    className="view-portfolio-btn"
                                    onClick={() =>
                                      openPortfolio(
                                        match.artisan_id,
                                        match.artisan_name,
                                      )
                                    }
                                  >
                                    <FaBriefcase /> View Portfolio
                                  </button>

                                  {match.has_proposal ? (
                                    <>
                                      <button
                                        className="view-proposal-btn"
                                        onClick={() =>
                                          handleViewProposal(match)
                                        }
                                      >
                                        <FaFileAlt /> View Proposal
                                      </button>
                                      <button
                                        className="select-artisan-btn"
                                        onClick={() =>
                                          handleSelectArtisan(match)
                                        }
                                        disabled={acceptingProposal}
                                      >
                                        <FaCheckCircle />
                                        {acceptingProposal
                                          ? 'Selecting...'
                                          : 'Select Artisan'}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="waiting-proposal-btn"
                                      disabled
                                    >
                                      <FaClock /> Awaiting Proposal
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Rating Section for Completed Projects */}
                    {viewRequest.status?.toLowerCase() === 'completed' && (
                      <div className="rating-section">
                        {existingRating ? (
                          <div className="existing-rating">
                            <h5>Your Review</h5>
                            <div className="stars-display">
                              {[...Array(5)].map((_, i) => (
                                <FaStar
                                  key={i}
                                  className="star"
                                  color={
                                    i < existingRating.score
                                      ? '#ffc107'
                                      : '#e4e5e9'
                                  }
                                />
                              ))}
                            </div>
                            {existingRating.review && (
                              <div className="review-text">
                                <strong>Comment:</strong>{' '}
                                {existingRating.review}
                              </div>
                            )}
                            {existingRating.images?.length > 0 && (
                              <div className="rating-images">
                                <strong>Photos:</strong>
                                <div className="images-grid">
                                  {existingRating.images.map((img, idx) => (
                                    <img
                                      key={idx}
                                      src={img.image_url}
                                      alt={`Review ${idx + 1}`}
                                    />
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="new-rating">
                            <h4>Rate Your Experience</h4>
                            <div className="stars-rating">
                              <label>Your Rating:</label>
                              <div className="stars-container">
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <FaStar
                                    key={star}
                                    className={`star ${star <= (hoverRating || rating) ? 'active' : ''}`}
                                    size={28}
                                    onMouseEnter={() => setHoverRating(star)}
                                    onMouseLeave={() => setHoverRating(0)}
                                    onClick={() => setRating(star)}
                                  />
                                ))}
                              </div>
                              <div className="rating-value">
                                {rating > 0
                                  ? `You rated: ${rating} star${rating > 1 ? 's' : ''}`
                                  : 'Click to rate'}
                              </div>
                            </div>

                            <div className="review-section">
                              <label>Your Review (Optional)</label>
                              <textarea
                                placeholder="Share your experience..."
                                value={ratingReview}
                                onChange={(e) =>
                                  setRatingReview(e.target.value)
                                }
                                className="review-textarea"
                                rows="3"
                              />
                            </div>

                            <div className="image-upload-section">
                              <label>Add Photos (Optional)</label>
                              <div className="file-upload-area">
                                <input
                                  type="file"
                                  multiple
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleImageUpload(
                                      e,
                                      setRatingImages,
                                      setRatingPreviewUrls,
                                    )
                                  }
                                  className="file-input"
                                />
                                <div className="upload-hint">
                                  <FaCamera className="upload-icon" />
                                  <div className="upload-text">
                                    <div className="upload-title">
                                      Click to upload images
                                    </div>
                                    <div className="upload-subtitle">
                                      PNG, JPG, WEBP up to 10MB
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {ratingPreviewUrls.length > 0 && (
                                <div className="preview-images">
                                  {ratingPreviewUrls.map((url, idx) => (
                                    <div
                                      key={idx}
                                      className="preview-image-wrapper"
                                    >
                                      <img
                                        src={url}
                                        alt={`Preview ${idx + 1}`}
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveImage(
                                            idx,
                                            setRatingImages,
                                            setRatingPreviewUrls,
                                          )
                                        }
                                      >
                                        ✖
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>

                            <button
                              className={`submit-rating-btn ${!rating ? 'disabled' : ''}`}
                              onClick={handleSubmitRating}
                              disabled={!rating || isSubmittingRating}
                            >
                              {isSubmittingRating
                                ? 'Submitting...'
                                : 'Submit Review'}
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* View Proposal Modal */}
        <Modal
          show={showProposalModal}
          onHide={() => {
            setShowProposalModal(false);
            setViewingProposal(null);
          }}
          centered
          size="lg"
          className="proposal-view-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Proposal from {viewingProposal?.artisan_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingProposal ? (
              <div className="proposal-loading">
                <div className="spinner"></div>
                <p>Loading proposal details...</p>
              </div>
            ) : viewingProposal ? (
              <div className="proposal-details">
                <div className="proposal-card">
                  <div className="proposal-header">
                    <div className="proposal-badge">
                      <FaFileAlt />
                      <span>Proposal Details</span>
                    </div>
                    <div
                      className={`proposal-status ${viewingProposal.is_selected ? 'accepted' : 'pending'}`}
                    >
                      {viewingProposal.is_selected
                        ? 'Accepted ✓'
                        : 'Pending Review'}
                    </div>
                  </div>

                  <div className="proposal-info-grid">
                    <div className="info-item">
                      <FaMoneyBillWave className="info-icon" />
                      <div>
                        <label>Proposed Amount</label>
                        <p className="amount">
                          KSh{' '}
                          {parseFloat(
                            viewingProposal.proposed_price || 0,
                          ).toLocaleString()}
                        </p>
                      </div>
                    </div>

                    <div className="info-item">
                      <FaCalendar className="info-icon" />
                      <div>
                        <label>Completion Date</label>
                        <p>
                          {viewingProposal.proposed_date_of_completion
                            ? new Date(
                                viewingProposal.proposed_date_of_completion,
                              ).toLocaleDateString()
                            : 'Not specified'}
                        </p>
                      </div>
                    </div>

                    <div className="info-item">
                      <FaClock className="info-icon" />
                      <div>
                        <label>Submitted On</label>
                        <p>
                          {viewingProposal.created_at
                            ? new Date(
                                viewingProposal.created_at,
                              ).toLocaleString()
                            : 'Date not available'}
                        </p>
                      </div>
                    </div>
                  </div>

                  {viewingProposal.note && (
                    <div className="proposal-message">
                      <label>Message from Artisan</label>
                      <div className="message-content">
                        <FaEnvelope className="message-icon" />
                        <p>{viewingProposal.note}</p>
                      </div>
                    </div>
                  )}

                  {viewingProposal.is_selected && (
                    <div className="proposal-selected-note">
                      <FaCheckCircle />
                      <span>
                        This proposal has been selected for the project!
                      </span>
                    </div>
                  )}

                  {!viewingProposal.is_selected && (
                    <div className="proposal-actions">
                      <button
                        className="select-proposal-btn"
                        onClick={async () => {
                          await handleSelectArtisan({
                            proposal_id: viewingProposal.id,
                            artisan_name: viewingProposal.artisan_name,
                            has_proposal: true,
                          });
                          setShowProposalModal(false);
                          setViewingProposal(null);
                        }}
                        disabled={acceptingProposal}
                      >
                        <FaCheckCircle />
                        {acceptingProposal
                          ? 'Selecting...'
                          : 'Select This Proposal'}
                      </button>

                      <button
                        className="message-artisan-btn"
                        onClick={() => {
                          setShowProposalModal(false);
                          setViewingProposal(null);
                          navigate(
                            `/messages?proposal=${viewingProposal.id}&project=${viewRequest?.title}&artisan=${viewingProposal.artisan_name}`,
                          );
                        }}
                      >
                        <FaComments /> Message Artisan
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="proposal-error">
                <FaTimes className="error-icon" />
                <p>Failed to load proposal details</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowProposalModal(false);
                setViewingProposal(null);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal
          show={!!editRequest}
          onHide={() => setEditRequest(null)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Project Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editRequest && (
              <div className="edit-modal-content">
                <form className="edit-form">
                  <div className="form-group">
                    <label>Project Title</label>
                    <input
                      type="text"
                      value={projectData.title}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          title: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      value={projectData.description}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Budget (KSh)</label>
                    <input
                      type="number"
                      value={projectData.budget}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          budget: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="text"
                      value={projectData.location}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          location: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Preferred Deadline</label>
                    <input
                      type="date"
                      value={projectData.deadline}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          deadline: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Upload New Images</label>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={(e) =>
                        handleImageUpload(e, setNewImages, setPreviewUrls)
                      }
                    />
                  </div>

                  {previewUrls.length > 0 && (
                    <div className="image-preview-grid-edit">
                      {previewUrls.map((url, idx) => (
                        <div key={idx} className="image-card edit-image">
                          <img
                            src={url}
                            alt="Preview"
                            className="thumbnail-edit-image"
                          />
                          <button
                            type="button"
                            className="remove-btn"
                            onClick={() =>
                              handleRemoveImage(
                                idx,
                                setNewImages,
                                setPreviewUrls,
                              )
                            }
                          >
                            ✖
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </form>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setEditRequest(null)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleEditProject}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Modal */}
        <Modal
          show={!!deleteRequest}
          onHide={() => setDeleteRequest(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Delete Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {deleteRequest && (
              <p>
                Are you sure you want to delete{' '}
                <strong>{deleteRequest.title}</strong>?
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setDeleteRequest(null)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteProject}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Portfolio Modal */}
        <Modal
          show={!!portfolioModal}
          onHide={closePortfolio}
          centered
          size="xl"
          className="portfolio-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {portfolioModal?.artisan_name}'s Portfolio
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="portfolio-content">
              <div className="artisan-profile">
                <div className="profile-header">
                  <div className="artisan-avatar">
                    <img
                      src={portfolioModal?.artisan_avatar}
                      alt={portfolioModal?.artisan_name}
                    />
                  </div>
                  <div className="profile-info">
                    <h3>{portfolioModal?.artisan_name}</h3>
                    <div className="rating-display">
                      <div className="stars">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            className="star"
                            color={
                              i < Math.round(portfolioModal?.client_rating || 0)
                                ? '#ffc107'
                                : '#e4e5e9'
                            }
                          />
                        ))}
                      </div>
                      <span className="rating-text">
                        {portfolioModal?.client_rating || '0'}/5
                      </span>
                    </div>
                    <span className="specialization">
                      {portfolioModal?.specialization || 'Furniture Artisan'}
                    </span>
                  </div>
                </div>
                <div className="artisan-bio">
                  <p
                    className={`bio-content ${expandedBios[portfolioModal?.artisan_id] ? 'expanded' : 'collapsed'}`}
                  >
                    {portfolioModal?.bio || 'No bio available'}
                  </p>
                  <button
                    className={`read-more-btn ${expandedBios[portfolioModal?.artisan_id] ? 'expanded' : ''}`}
                    onClick={() => toggleBio(portfolioModal?.artisan_id)}
                  >
                    {expandedBios[portfolioModal?.artisan_id]
                      ? 'Read Less'
                      : 'Read More'}
                  </button>
                </div>
              </div>

              <div className="portfolio-stats">
                <div className="stat-card">
                  <div className="stat-number">
                    {portfolioModal?.projects_completed || '0'}
                  </div>
                  <div className="stat-label">Projects Completed</div>
                </div>
                <div className="stat-card">
                  <div className="stat-number">
                    {portfolioModal?.years_of_experience || '0'}+
                  </div>
                  <div className="stat-label">Years Experience</div>
                </div>
              </div>

              <div className="portfolio-projects-section">
                <div className="section-title">
                  <h4>Featured Projects</h4>
                  <p>Explore the artisan's completed work and craftsmanship</p>
                </div>
                {portfolioModal?.portfolio_items?.length > 0 ? (
                  <div className="projects-grid">
                    {portfolioModal.portfolio_items.map((project) => (
                      <div key={project.id} className="portfolio-project-card">
                        <div className="carousel-container">
                          {project.images?.length > 0 ? (
                            <div className="carousel-wrapper">
                              {project.images?.map((img, index) => (
                                <img
                                  key={img.id}
                                  src={img.image}
                                  alt={`${project.title} ${index + 1}`}
                                  className={`carousel-image ${index === (carouselIndex[project.id] || 0) ? 'active-image' : 'inactive-image'}`}
                                />
                              ))}
                            </div>
                          ) : (
                            <div className="image-placeholder">
                              <FaImage className="placeholder-icon" />
                              <span className="placeholder-text">
                                No images available
                              </span>
                            </div>
                          )}
                          <button
                            className="carousel-btn left"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePrev(project.id, project.images.length);
                            }}
                          >
                            ‹
                          </button>
                          <button
                            className="carousel-btn right"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNext(project.id, project.images.length);
                            }}
                          >
                            ›
                          </button>
                          {project.images?.length > 1 && (
                            <div className="carousel-indicators">
                              {project.images.map((_, index) => (
                                <div
                                  key={index}
                                  className={`indicator ${index === (carouselIndex[project.id] || 0) ? 'active' : ''}`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCarouselIndex((prev) => ({
                                      ...prev,
                                      [project.id]: index,
                                    }));
                                  }}
                                />
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="project-info">
                          <h5>{project.title}</h5>
                          <div className="project-description">
                            <p
                              className={`description-content ${expandedDescriptions[project.id] ? 'expanded' : 'collapsed'}`}
                            >
                              {project.description}
                            </p>
                            {project.description &&
                              project.description.length > 100 && (
                                <button
                                  className={`read-more-btn ${expandedDescriptions[project.id] ? 'expanded' : ''}`}
                                  onClick={() => toggleDescription(project.id)}
                                >
                                  {expandedDescriptions[project.id]
                                    ? 'Read Less'
                                    : 'Read More'}
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="portfolio-empty-state">
                    <div className="empty-icon">🎨</div>
                    <h4>No Projects Yet</h4>
                    <p>
                      This artisan hasn't added any projects to their portfolio
                      yet.
                    </p>
                  </div>
                )}
              </div>

              <div className="skills-section">
                <h5>Specializations & Skills</h5>
                <div className="skills-grid">
                  {portfolioModal?.skills?.length > 0 ? (
                    portfolioModal.skills.map((skill, index) => (
                      <span key={index} className="skill-tag">
                        {skill}
                      </span>
                    ))
                  ) : (
                    <>
                      <span className="skill-tag">Woodworking</span>
                      <span className="skill-tag">Custom Furniture</span>
                      <span className="skill-tag">Carpentry</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closePortfolio}>
              Close Portfolio
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Confirmation Modal for Selecting Artisan */}
        <Modal
          show={showConfirmModal}
          onHide={() => {
            setShowConfirmModal(false);
            setSelectedMatchForConfirm(null);
          }}
          centered
          className="confirm-select-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Artisan Selection</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedMatchForConfirm && (
              <div className="confirmation-content">
                <div className="confirmation-icon">
                  <FaCheckCircle className="warning-icon" />
                </div>
                <p className="confirmation-question">
                  Are you sure you want to select{' '}
                  <strong>{selectedMatchForConfirm.artisan_name}</strong> for
                  this project?
                </p>

                <div className="confirmation-details">
                  <div className="detail-row">
                    <span className="detail-label">Project:</span>
                    <span className="detail-value">{viewRequest?.title}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Artisan:</span>
                    <span className="detail-value">
                      {selectedMatchForConfirm.artisan_name}
                    </span>
                  </div>
                  <div className="detail-row highlight">
                    <span className="detail-label">Agreed Amount:</span>
                    <span className="detail-value amount">
                      KSh{' '}
                      {selectedMatchForConfirm.final_agreed_amount
                        ? parseFloat(
                            selectedMatchForConfirm.final_agreed_amount,
                          ).toLocaleString()
                        : parseFloat(
                            selectedMatchForConfirm.proposed_price,
                          ).toLocaleString()}
                    </span>
                  </div>
                </div>

                <div className="confirmation-warning">
                  <p>
                    ⚠️ <strong>Note:</strong> Once you select this artisan:
                  </p>
                  <ul>
                    <li>
                      Other proposals for this project will be automatically
                      declined
                    </li>
                    <li>The artisan will be notified and project will start</li>
                    <li>
                      You will be able to communicate with the artisan through
                      messages
                    </li>
                    <li>This action cannot be undone</li>
                  </ul>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowConfirmModal(false);
                setSelectedMatchForConfirm(null);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={confirmSelectArtisan}
              disabled={acceptingProposal}
              className="confirm-select-btn"
            >
              {acceptingProposal ? (
                <>
                  <FaSpinner className="spinning" /> Selecting...
                </>
              ) : (
                <>
                  <FaCheckCircle /> Yes, Select Artisan
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(MyRequests, 'client');
